import { Logger } from "@devforce/trailhead-client-logger";

export const logger = new Logger({
  prefix: "[th-profile-ui]: ",
});
